import React, { FC, useState } from 'react';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { ContainedList } from 'components/organisms/notifications/list/line-item/contained-list';

const items = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];

export const ContainedListDemo: FC = () => {
  const [select, setSelect] = useState(4);
  const [show, setShow] = useState(2);
  const title = 'Contained list';

  return (
    <>
      <h3>{title}</h3>
      <Form layout="inline">
        <Form.Item label="Total:">
          <Input
            type="number"
            min={1}
            max={8}
            value={select}
            onChange={(e) => setSelect(e.target.valueAsNumber ?? 4)}
          />
        </Form.Item>
        <Form.Item label="Show:">
          <Input
            type="number"
            min={1}
            max={8}
            value={show}
            onChange={(e) => setShow(e.target.valueAsNumber ?? 2)}
          />
        </Form.Item>
      </Form>
      <hr />
      <ContainedList items={items.slice(0, select)} show={show} />
    </>
  );
};
